var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommentAlt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "comment-alt_1_",
    "data-name": "comment-alt(1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.181,
    height: 12.068,
    viewBox: "0 0 12.181 12.068",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_68485",
    "data-name": "Path 68485",
    d: "M9.39,0h-6.6A2.8,2.8,0,0,0,0,2.792V7.36a2.8,2.8,0,0,0,2.792,2.792h.73L5.6,11.891a.761.761,0,0,0,.977,0l2.081-1.74h.73A2.8,2.8,0,0,0,12.181,7.36V2.792A2.8,2.8,0,0,0,9.39,0Zm1.269,7.36A1.269,1.269,0,0,1,9.39,8.629H8.383a.761.761,0,0,0-.488.178l-1.8,1.508-1.8-1.508A.761.761,0,0,0,3.8,8.629H2.792A1.269,1.269,0,0,1,1.523,7.36V2.792A1.269,1.269,0,0,1,2.792,1.523h6.6a1.269,1.269,0,0,1,1.269,1.269Z",
    fill: "#586973"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_68486",
    "data-name": "Path 68486",
    d: "M6.761,7.523H8.284A.761.761,0,1,0,8.284,6H6.761a.761.761,0,0,0,0,1.523Z",
    transform: "translate(-2.955 -2.955)",
    fill: "#586973"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_68487",
    "data-name": "Path 68487",
    d: "M11.329,11H6.761a.761.761,0,1,0,0,1.523h4.568a.761.761,0,0,0,0-1.523Z",
    transform: "translate(-2.955 -5.417)",
    fill: "#586973"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentAlt);
export default __webpack_public_path__ + "static/media/comment-alt.76fb9752.svg";
export { ForwardRef as ReactComponent };